import { helper } from '@ember/component/helper';

/**
 * The inverse of `not-in-archive`: only the items that have actually been
 * archived. A missing `archived` value counts as *not* archived — every scan
 * created before the field has no value — so it is excluded here for the same
 * reason `not-in-archive` includes it.
 */
export default helper(function inArchive([list]) {
  return (list ?? []).filter((item) => item.archived === true);
});
